module.exports = __webpack_public_path__ + "static/media/menu-white.ae86a645.svg";